import { isString } from 'angular';

import { EMAIL_REGEXP } from '@contact/upgrade';

export function isEmailValid(emailAdress: string): boolean {
  return isString(emailAdress) && emailAdress.length > 0 && EMAIL_REGEXP.test(emailAdress as string);
}
